import { FilterTypes } from "../enums/filterTypes";
import { Employee } from "../models/employee";
import { FilterViewModel } from "../models/filter/filterViewModel";

export class AssignMeAsOwnerOrApproverFilterUtilities {

  static addCurrentUserAsOwnerOrApprover(
    filters: FilterViewModel[],
    employee: Employee,
    allowedFilters: FilterViewModel[],
    filterType: FilterTypes = FilterTypes.Owner
  ): { filters: FilterViewModel[], ownerValue: any } {

    if (!allowedFilters || !employee) {
      return { filters, ownerValue: null };
    }

    const empFilter = allowedFilters.find(
      (s: any) => s.filterType === filterType &&
      s.filterValue.toString() === employee.id.toString()
    );

    if (!empFilter) {
      return { filters, ownerValue: null };
    }

    const currentOwnerFilter = filters.find(f => f.filterType === filterType);

    if (currentOwnerFilter?.filterValue === empFilter.filterValue) {
      return { filters, ownerValue: empFilter.filterValue };
    }

    // Remove existing owner/approver filter if different
    const updatedFilters = filters.filter((f) => f.filterType !== filterType);

    return {
      filters: [...updatedFilters, empFilter],
      ownerValue: empFilter.filterValue
    };
  }
}
